import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue, remove } from "firebase/database";
import app from "../../../firebaseConfig";

import ProteccionBarra from "./proteccionbarra";


function Bar() {
  const [pedidos, setPedidos] = useState([]);

  useEffect(() => {
    const db = getDatabase(app);
    const pedidosRef = ref(db, "nature/Awoo/Pedidos/Direccionados/Barra");
    
    onValue(pedidosRef, (snapshot) => {
      if (snapshot.exists()) {
        const pedidosData = snapshot.val();
        const pedidosArray = Object.keys(pedidosData).map((key) => {
          const pedido = pedidosData[key];
          return {
            id: key,
            ...pedido,
            productos: Object.values(pedido.productos || {}),
          };
        });

        // Ordenar pedidos por fecha y hora
        pedidosArray.sort((a, b) => {
          const fechaA = new Date(`${a.fecha} ${a.hora}`);
          const fechaB = new Date(`${b.fecha} ${b.hora}`);
          return fechaA - fechaB;
        });

        setPedidos(pedidosArray);
      } else {
        setPedidos([]);
      }
    });
  }, []);

  const handleEntrega = (id) => {
    if (window.confirm("¿Seguro que el pedido se entregó?")) {
      const db = getDatabase(app);
      remove(ref(db, `nature/Awoo/Pedidos/Direccionados/Barra/${id}`));
    }
  };

  return (

    
    <ProteccionBarra>

         <div style={{
      display: "flex",
      flexDirection: "column",
      height: "100vh",
      background: "#000",
      padding: "20px",
    }}>
      {/* Título */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "10px",
          backgroundColor: "#22cfe3",
          borderRadius: "10px",
          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
          marginBottom: "15px",
        }}
      >
        <strong style={{ fontSize: "20px", color: "#fff" }}>🍷 Barra 🍸🍹</strong>
      </div>

      <div style={{
        flex: 1,
        backgroundColor: "#111",
        borderRadius: "15px",
        padding: "15px",
        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
        overflowY: "auto",
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: "15px",
      }}>
        {pedidos.length === 0 ? (
          <p style={{ color: "#aaa", textAlign: "center" }}>
            No hay pedidos pendientes
          </p>
        ) : (
          pedidos.map((pedido, index) => (
            <div key={pedido.id} style={{
              background: "#1c1c1c",
              padding: "18px",
              borderRadius: "15px",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.4)",
              color: "#fff",
              position: "relative",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              borderLeft: "6px solid #00ff99",
            }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" , marginTop:"-11px"}}>
                <strong style={{ fontSize: "20px", color: "#00ff99" }}>📋 Pedido {index + 1}</strong>
                <button
                  onClick={() => handleEntrega(pedido.id)}
                  style={{
                    backgroundColor: "#00ff99",
                    color: "#000",
                    borderRadius: "50%",
                    width: "32px",
                    height: "32px",
                    border: "none",
                    cursor: "pointer",
                    fontWeight: "bold",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.4)"
                  }}
                >✅</button>
              </div>
      
              <div style={{ fontSize: "13px", color: "#bbb", display: "flex", justifyContent: "space-between" }}>
                <span>🗓️ {pedido.fecha}</span>
                <span>⏰ {pedido.hora}</span>
              </div>
      
              <div style={{ marginTop:"-15px" , display: "flex", justifyContent: "space-between", gap: "10px"}}>
                <p><strong>🪑 Mesa:</strong> {pedido.mesa}</p>
                <p><strong>👤 Titular:</strong> {pedido.titular}</p>
              </div>
      
              <div style={{marginTop: "-20px", fontSize: "15px", color: "#fff" }}>
                🧍 <strong>Mesero:</strong> {pedido.empleado}
              </div>
      
              <div style={{
                backgroundColor: "#fff",
                color: "#000",
                borderRadius: "10px",
                padding: "10px 12px",
                marginTop: "10px",
                boxShadow: "inset 0 0 5px rgba(0,0,0,0.1)"
              }}>
                <strong style={{ fontSize: "15px", color: "#333" }}>🍽️ Productos:</strong>
                <ul style={{ paddingLeft: "20px", marginTop: "5px" }}>
                  {pedido.productos.map((producto, i) => (
                    <li key={i} style={{ marginBottom: "4px", listStyle: "none" }}>
                      ✔️ {producto.titulo} <strong>x{producto.cantidad}</strong>
                    </li>
                  ))}
                </ul>
              </div>
      
              {pedido.nota && pedido.nota.trim() !== "" && (
                <div style={{
                  backgroundColor: "#333",
                  borderRadius: "8px",
                  padding: "10px",
                  borderLeft: "4px solid #ff9900",
                  color: "#ffcc80",
                  marginTop: "8px"
                }}>
                  📝 <strong>Nota:</strong> {pedido.nota}
                </div>
              )}
            </div>
          ))
        )}
      </div>
    </div> 
    </ProteccionBarra>




  );
}

export default Bar;
